import './LongText.styles.scss';

import { Tooltip } from 'primereact/tooltip';
import { FC, memo, SyntheticEvent, useMemo } from 'react';
import { v4 as uuidv4 } from 'uuid';

import notificationStore from '../../store/NotificationStore';
import { copyToClipboard } from '../../utils/keyboard.utils';
import { LongTextProps } from './LongText.types';

const LongText: FC<LongTextProps> = ({
  text,
  onCopyText,
  onCopy,
  onCopyData,
  position = 'bottom',
}) => {
  const id = useMemo(() => `text-${uuidv4()}`, []);

  const copyText = (e: SyntheticEvent): void => {
    e.stopPropagation();
    onCopy
      ? onCopy(onCopyData ?? text)
      : copyToClipboard(text).then(() => {
          notificationStore.showNotification({
            severity: 'success',
            summary: 'Success',
            detail: onCopyText,
          });
        });
  };

  return (
    <>
      <Tooltip target={`#${id}`} content={text} position={position} />
      <div
        className="LongText-Component cursor-pointer"
        id={id}
        onClick={copyText}
      >
        {text}
      </div>
    </>
  );
};

export default memo(LongText);
